<template>
  <!-- 到柜列表 -->
  <div class="container">
    <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="到柜列表" name="first">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList">
          <div class="glo_btnList_left">
            <el-button class="glo_btnItems glo_bgcMainColor" @click="onVisitLoadingDetails('readonly')"
              >查看</el-button
            >
            <el-button class="glo_btnItems glo_bgcMainColor" @click="onConfirmIntoStorage()"
              >入仓确认</el-button>
            <el-button class="glo_btnItems glo_bgcMainColor" @click="onCancelConfirmIntoStorage()"
              >取消入仓确认</el-button>
            <el-button class="itemBtn" @click="myModel"
            >表格设置</el-button
            >
            <el-button plain class="jy-button"
            >打印入库清单</el-button
            >
            <template >
              <div class="tableExportBtn">
                <exportTb
                    :theadData="myTableHeard"
                    :tableData="tableData"
                    :resultData="tableData"
                    @handleExportDia_dc="handleExportDia_dc('到达管理')"
                ></exportTb>
              </div>
            </template>
          </div>
          <queryBtns
            :MoreConditions="MoreConditions"
            @clerBtns="clerBtns"
            @queryBtn_ok="queryBtn_ok"
            @moreParam="moreParam"
          ></queryBtns>
        </div>
        <!-- 查询条件 -->
        <!-- :formData="queryData" -->
        <queryCondition
          ref="queryForm"
          :More="isHaseMore"
          :formConfig="queryCondditionDatas"
        ></queryCondition>
        <!-- 表格 -->
        <div class="glo_Table">
          <el-table
            :height="tableHeigth"
            header-align="center"
            ref="mytable"
            @row-click="rowclick"
            :data="tableData"
            border
            stripe
            :highlight-current-row="true"
            show-summary
            :summary-method="getSummaries"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>
            <template v-for="(item, index) in myTableHeard">
              <!-- 某个字段需要单独操作  例如点击可以跳转 -->
              <el-table-column
                v-if="item.field === 'aaaaaaaaaa' && item.isShow"
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="left"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
              >
                <template slot-scope="scope">
                  <div class="linkTabel">
                    {{ scope.row.aaaaaaaaaa }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-else-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>

        <!-- 分页 -->
        <paging
          ref="pags"
          :pageNum="pageStart"
          :total="pageCount"
          :size="pageTotal"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </el-tab-pane>
      <el-tab-pane label="到柜明细" name="second">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList">
          <div class="glo_btnList_left">
            <el-button class="itemBtn btnColor" @click="myModel"
            >表格设置</el-button
            >
            <template >
              <div class="tableExportBtn">
                <exportTb
                    :theadData="myTableHeard"
                    :tableData="tableData"
                    :resultData="tableData"
                    @handleExportDia_dc="handleExportDia_dc('到达管理明细')"
                ></exportTb>
              </div>
            </template>
          </div>
          <queryBtns
              :MoreConditions="MoreConditions"
              @clerBtns="clerBtns"
              @queryBtn_ok="queryBtn_ok"
              @moreParam="moreParam"
          ></queryBtns>
        </div>
        <!-- 查询条件 -->
        <!-- :formData="queryData" -->
        <queryCondition
            ref="queryForm"
            :More="isHaseMore"
            :formConfig="queryCondditionDatas"
        ></queryCondition>
        <!-- 表格 -->
        <div class="glo_Table">
          <el-table
              :height="tableHeigth"
              header-align="center"
              ref="mytable"
              @row-click="rowclick"
              :data="tableData"
              border
              stripe
              :highlight-current-row="true"
              show-summary
              :summary-method="getSummaries"
              @selection-change="handleSelectionChange"
          >
            <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
            ></el-table-column>
            <el-table-column
                fixed="left"
                align="center"
                type="selection"
                width="60"
            ></el-table-column>
            <template v-for="(item, index) in myTableHeard">
              <!-- 某个字段需要单独操作  例如点击可以跳转 -->
              <el-table-column
                  v-if="item.field === 'aaaaaaaaaa' && item.isShow"
                  :key="index"
                  :label="item.name"
                  :prop="item.field"
                  align="left"
                  sortable
                  :show-overflow-tooltip="true"
                  :min-width="item.width"
                  :data-isTotal="item.isTotal"
              >
                <template slot-scope="scope">
                  <div class="linkTabel">
                    {{ scope.row.aaaaaaaaaa }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  :key="index"
                  :label="item.name"
                  :prop="item.field"
                  align="center"
                  sortable
                  :show-overflow-tooltip="true"
                  :min-width="item.width"
                  :data-isTotal="item.isTotal"
                  v-else-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>

        <!-- 分页 -->
        <paging
            ref="pags"
            :pageNum="pageStart"
            :total="pageCount"
            :size="pageTotal"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
        ></paging>


      </el-tab-pane>
    </el-tabs>
    <!--入仓确认 -->
    <Dialog
        :show="commonDocVisible"
        class="dialog-padding-container"
        title="入仓确认"
        width="500"
        @onCancel="onCancelAnnex"
        @onConfirm="onConfirm"
        :footer="true"
    >
      <el-form :model="ruCangData" label-position="left">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item
                label="入仓仓库："
                class="jy-form-select"
                prop="arrivalStorageId"
            >
              <el-select
                  v-model="ruCangData.arrivalStorageId"
                  placeholder="请选择"
                  clearable
                  @visible-change="visibleChange($event, 5)"
              >
                <el-option
                    v-for="(item, index) in storageOptions"
                    :key="index"
                    :label="item.storageName"
                    :value="item.storageId"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="入仓时间：" class="jy-form-time">
              <el-date-picker
                  v-model="ruCangData.arrivalTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="请选择"
                  type="datetime"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </Dialog>
    <!--        自定义表头           -->
    <sorttable
        :show_sortTableHeard="show_sortTableHeard"
        :allCheck="allCheck"
        :sortName="sortName"
        :tabelHeadeTitle="tabelHeadeTitle"
        :originalTabelHeadeTitle="originalTabelHeadeTitle"
        :selectLength="selectLength"
        @cancelSortHeard="cancelSortHeard"
        @confirmOk="confirmOk"
        @checktab="checktab"
        @checkAll="checkAll"
        @closeDias="closeDias"
    ></sorttable>

    <!-- 导出插件 -->
    <exportComponent
        :isShowDialog_dc="exportForm.isShowDialog_dc"
        :diaWidth_dc="exportForm.diaWidth_dc"
        :diaHeight_dc="exportForm.diaHeight_dc"
        :dialogTitle="exportForm.dialogTitle"
        :dialogForm_dc="exportForm.dialogForm_dc"
        :data="exportForm.queryForm"
        :tableHeard="exportForm.EPtableHeard"
        :AllCheck="exportForm.EPAllCheck"
        @checktabEP="checktabEP"
        @checkAllEP="checkAllEP"
        @onAfterEnter="onAfterEnter"
        @handleCloseDia_dc="handleCloseDia_dc"
        @diaConfirmBtn_dc="diaConfirmBtn_dc"
        queryType="exportModeList"
    >
    </exportComponent>
  </div>
</template>
  <script>
import tableList from "@/pages/DynamicList/tableList.js";
//   import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtnsDT.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/DialogDT.vue";
import { Message as ElMessage, MessageBox as ElMessageBox } from 'element-ui'
import utils from "@/assets/js/tool";
//   import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import customerModelService from "@/components/customerService/modelIndex.vue";
import { Api } from "@/assets/js/api";
import exportTb from "@/components/exportComponent/exportTb.vue";
import exportComponent from "@/components/exportComponent/index.vue";
import tableListNew from "@/pages/tableListNew.js";
import sorttable from "@/components/sortTemplate.vue";

export default {
  mixins: [tableList,tableListNew],
  inject: ["reload"],
  components: {
    sorttable,
    exportComponent,
    exportTb,
    //   sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
    customerModelService,
  },
  data() {
    return {
      sortName : "到达管理",
      userList: [],

      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "到达管理", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd===等待下载完成,bdd===不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "arrivalManagementToCabinetList", //  页面标识
      reportFiledsNumber: "pageArriveEntruck", // 动态 条件、表头
      pageGroupNameMap: {
        first: "arrivalManagementToCabinetList", // 到柜列表
        second: "arrivalManagementToCabinetDetail" // 到柜明细
      },
      currentItemArr: [],
      dialogType: "",
      showTimers:false,
      dataList: [],
      oneDocuNumber: "",
      customerModelServiceStatus: false,
      mxSearchHeight: 71,
      activeName: "first",
      reqNumber: "pageArriveEntruck",
      reqDetailNumber: "pageArriveEntruck_detail",
      mxReqNumber: "pageArriveEntruck_detail",
      tabCache: {
        first: {
          queryData: {},
          tableData: [],
          queryCondditionDatas: [],
          tableHeader: []  // 添加这个字段
        },
        second: {
          queryData: {},
          tableData: [],
          queryCondditionDatas: [],
          tableHeader: []  // 添加这个字段
        }
      },
      currentTab: 'first',
      ruCangData:{
        arrivalStorageId: "",
        arrivalTime: "",
        entruckId: [],
      },
      commonDocVisible: false,
      storageOptions: [],
      confirmIntoStorageVisible : false,
    };
  },
  mounted() {
    this.queryBtn_ok();
  },
  watch: {

  },
  methods: {

    mxSetHeight(num) {
      this.mxSearchHeight = num + 15;
    },
    handleClick(tab, event) {
      // 保存当前 tab 的状态
      if (this.activeName && this.$refs.queryForm) {
        const currentFormData = this.$refs.queryForm.getFormData ?
            this.$refs.queryForm.getFormData() :
            this.$refs.queryForm.formData;

        if (!this.tabCache) {
          this.tabCache = {
            first: {},
            second: {}
          };
        }

        // 缓存当前 tab 的数据
        this.tabCache[this.activeName] = {
          ...this.tabCache[this.activeName],
          queryData: currentFormData,
          pageStart: this.pageStart
        };
      }

      // 切换 tab
      this. activeName = tab.name;
      this.sortName = "到达管理";
      this.pageGroupName = this.pageGroupNameMap[tab.name];
      let rqNumber = "pageArriveEntruck";
      if (tab.name === "second") {
        this.mxSearchHeight = this.mxSearchHeight > 86 ? this.mxSearchHeight : 86;
        rqNumber = "pageArriveEntruck_detail";
        this.sortName = "到达管理明细";
      }

      // 初始化目标 tab
      this.initTableByTab(tab.name, rqNumber);
    },
    // 表格选择事件
    handleSelectionChange(e) {
      this.currentItemArr = e || [];
    },

    // 不能输入负数
    minNum(val) {
      return val < 0 ? 0 : val;
    },
    //查看柜单详情
    onVisitLoadingDetails(type, data){
      var list = this.currentItemArr || [];
      if (data) {
        list = [data];
      }
      if (list.length === 1) {
        let obj = {
          status: type,
          id: list[0].entruckId,
          tagTitle: "查看出库详情",
        };
        this.$router.push({
          path: "/pages/v4/entruck/entruckDetails",
          query: obj
        });
      } else {
        ElMessage({
          message: "请选择1条表格数据",
          type: "warning",
        });
      }
    },
    onConfirmIntoStorage (){
      if (this.currentItemArr.length >= 1) {
        this.commonDocVisible = true;
        this.ruCangData.arrivalTime = utils.getCurrentTime();
        this.ruCangData.entruckId = this.currentItemArr.map((item) => {
          return item.entruckId;
        });
      } else {
        ElMessage({
          message: "请选择表格数据",
          type: "warning",
        });
      }
    },
    onCancelAnnex(){
      this.commonDocVisible = false;
      this.ruCangData.arrivalStorageId = "";
      this.ruCangData.arrivalTime = "";
      this.ruCangData.entruckId = [];
    },
    onConfirm(){
      Api.confirmIntoStorage(this.ruCangData).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (utils.jyCheckObjectType(data) === "Object") {
            ElMessage({
              message: data.message,
              type: data.status,
            });

            this.onCancelAnnex();
            let that = this;
            setTimeout(() => {
              that.queryBtn_ok();
            }, 500);
          }
        }
        this.commonDocVisible = false;
      });
    },

    //取消入库确认
    async onCancelConfirmIntoStorage (){
      if (this.currentItemArr.length >= 1) {
        ElMessageBox.confirm("是否取消入库确认所选数据？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(async () => {
              const idList = this.currentItemArr.map((item) => {
                return item.entruckId;
              });
              let params = {
                entruckId: idList,
              };
              await Api.cancelIntoStorage(params).then((res) => {
                if (res.status === 200) {
                  const data = res.data;
                  if (utils.jyCheckObjectType(data) === "Object") {
                    ElMessage({
                      message: "取消入库确认成功",
                      type: data.status,
                    });
                    let that = this;
                    setTimeout(() => {
                      that.queryBtn_ok();
                    }, 500);
                  }
                }
              });
            })
            .catch(() => {});
      } else {
        ElMessage({
          message: "请选择表格数据",
          type: "warning",
        });
      }
    },

    async visibleChange(val, type){
      if (val) {
        if (type === 3) {
        } else if (type === 4) {
        } else if (type === 5 || type === 6) {
          utils.getSelectData("storage_choose_list", 1).then((res) => {
            this.storageOptions = res.arr;
          });
        } else if (type === 7) {
        } else if (type === 8) {
        } else if (type === 9) {
        } else if (type === 10) {
        } else if (type === 11) {
        } else if (type === 12) {
        }
      }
    },

  },




};
</script>
  <style scoped lang="scss">
::v-deep .el-date-editor.el-input {
  width: auto !important;
}

.classA {
  display: flex;
}

.glo_dialogForm .diaForm .dialogFormItems {
  height: 30px !important;
  line-height: 30px !important;
  overflow: hidden;
}

.couponBox {
  width: 100%;
  margin-bottom: 20px;
  height: 34px;

  .couponitmeInput {
    width: 100px;
    border: 1px solid #cccccc;
    margin: 0 6px;

    ::v-deep .el-input__inner {
      height: 30px;
      line-height: 30px;
    }
  }

  .couponItemA {
    display: flex;
    align-items: center;
  }
}

.displays {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.rows {
  display: flex;
  width: 100%;
}

.multipleSelect {
  ::v-deep .el-select {
    border: 1px solid #cccccc;
    border-radius: 4px;
  }
}
</style>
  